<template>
    <div class="ICP-centent" :style="{background:bgcClor,color:color}">
      <div class="ICP">
       
        Copyright © {{new Date().getFullYear()}} malink.cn All rights reserved.
        &nbsp;&nbsp;&nbsp;&nbsp;
        <a class="ICP-url"
          :style="{color:color}"
          href="http://beian.miit.gov.cn/">
          京ICP备14038000号-19
        </a>
      </div>
   
    </div>
</template>

<script>
export default {
  props:['bgcClor','color'],
};
</script>

<style scoped lang="scss">
.ICP-centent {
    position: relative;
    line-height: 54px;
    color: #999999;
    background-color: #F5F7FA;
    z-index: 2;
    
    .ICP{
      margin: 0 auto;
      width: 1200px;
      text-align: center;
      
        a {
          color: #999999;
          text-decoration:none;
      }
    }
}
</style>
